<template>
    <div class="card mb-2">
        <div class="row g-0 box-card-title" :style="customSize">
            <div :class="'col-md-1 line-card ' + class_color" :style="customSizeColorBorder">
            </div>
            <div class="col-md-11" style="width: 99.5%;">
                <div class="card-body" :style="style_body">
                    <slot name="context" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'Card_Tab',
        props: {
            class_color: {
                type: String,
                default: 'bg-color-1'
            },
            customSize: {
                type: String,
                default: ''
            },
            customSizeColorBorder: {
                type: String,
                default: ''
            },
            style_body: {
                type: String,
                default: ''
            }
        },

    }

</script>

<style scoped lang="scss">

    .card-body {
        max-height: 70px;
    }

    .card {
        border-color: transparent;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
    }

    .box-card-title {
        font-size: 11px;
    }

    .line-card {
        border-radius: 10px 0px 0px 10px;
        max-width: 0.5%;
        margin-left: -3px;
        margin-top: -1px;
        margin-bottom: -2px;
    }
</style>